export enum AnonymousRegistration {
  id = '00000000-0000-0000-0000-000000000000'
}

export const UNKNOWN_VETERINARIAN_ID = '00000000-0000-0000-0000-000000000001';

export const PUBLIC_EMAIL_DOMAIN = 'pawfinders.com';
